import usStateCodes from 'us-state-codes';

/**
 * Given a state two-character postal code, returns the corresponding name.
 * @param {string} code - The two-character postal code of the state to look up.
 * @returns {string} - The name of the state, or a default of null if not available.
 */
export default function getStateNameFromCode(code) {
  return usStateCodes.getStateNameByStateCode(code) || null;
}
